import React from "react";
import { graphql } from "gatsby";
import { Stack, Container } from "@mui/material";
import SEO from "../components/Seo";
import NavigationWrapper from "../components/layout/NavigationWrapper";
import AppGreeterShowcase from "../components/sections/GreeterAppShowcase";
import CampaignShowcase from "../components/sections/CampaignShowcase";
import ReviewShowCase from "../components/sections/ReviewShowcase";
import MostReadArticlesShowcase from "../components/sections/MostReadArticlesShowcase";
import AboutHordeAbstract from "../components/sections/AboutHordeAbstract";
import PodcastShowCase from "../components/sections/PodcastShowcase";
import COLORS from "../constants/colors";
import { AppPageQuery } from "../interfaces/sanity/sanityClasses";
import AboutHordePlusAbstract from "../components/sections/AboutHordePlusAbstract";
import HordetFondetAbstract from "../components/sections/HordeFondetAbstract";

export const query = graphql`
  query MainPage {
    allSanityPost(
      filter: { promoted: { eq: true } }
      limit: 3
      sort: { publishedAt: DESC }
    ) {
      edges {
        node {
          id
          mainImage {
            asset {
              _id
            }
          }
          title
          slug {
            current
          }
          excerpt
          previewImage {
            asset {
              _id
            }
          }
          categories {
            title
            description
            id
          }
        }
      }
    }
    allSanityAppReview(limit: 4, sort: { date: DESC }) {
      edges {
        node {
          id
          content
          stars
          reviewer
          date(formatString: "DD-MM-YYYY")
          title
        }
      }
    }
    allSanityCampaign(filter: { activeCampaign: { eq: true } }) {
      edges {
        node {
          id
          campaignTitle
          activeCampaign
          campaignTitleDecoration
          thumbnailImage {
            asset {
              _id
            }
          }
          slug {
            current
          }
          _rawCampaignLead
          textColor {
            hex
          }
          bgColor {
            hex
          }
        }
      }
    }
  }
`;

const IndexPage = ({ data }: AppPageQuery) => {
  const reviews = data.allSanityAppReview.edges.map((e) => ({
    content: e.node.content ?? "",
    title: e.node.title ?? "",
    starsNr: parseFloat(e.node.stars ?? "0"),
    dateOfReview: e.node.date ?? Date(),
    reviewerName: e.node.reviewer ?? "",
  }));

  return (
    <NavigationWrapper>
      <AppGreeterShowcase />
      <CampaignShowcase activeCampaigns={data.allSanityCampaign.edges} />
      <Stack bgcolor={COLORS.BRIGHT_BLUE[60]}>
        <HordetFondetAbstract />
      </Stack>
      <Stack bgcolor={COLORS.DARK_BLUE[100]}>
        {/* <AboutHordePlusAbstract /> */}
        <MostReadArticlesShowcase articles={data.allSanityPost.edges} />
      </Stack>

      <Stack bgcolor={COLORS.BRIGHT_BLUE[40]}>
        <AboutHordeAbstract />
      </Stack>
      <Stack
        bgcolor={{ xs: COLORS.BRIGHT_BLUE[40], md: COLORS.BRIGHT_BLUE[40] }}
      >
        {/* <ReviewShowCase reviews={reviews} bgcolor={COLORS.BRIGHT_BLUE[60]} /> */}
        <Stack
          component="section"
          bgcolor={COLORS.BRIGHT_BLUE[20]}
          pt={{ xs: "48px", md: "100px" }}
          pb={{ xs: "48px", md: "100px" }}
        >
          <Container
            maxWidth="lg"
            sx={{
              paddingX: { xs: "0px", md: "23px" },
            }}
          >
            <PodcastShowCase
              bgcolor={COLORS.BRIGHT_BLUE[40]}
              borderRadius="16px"
            />
          </Container>
        </Stack>
      </Stack>
    </NavigationWrapper>
  );
};

export default IndexPage;

export function Head() {
  return (
    <SEO
      title="Horde - Bli sjef i egen økonomi"
      description="Få full oversikt over dine kredittkort, forbrukslån, kontoer og private låneavtaler. Motta tips for en bedre økonomi og spar penger med gode tilbud!"
    />
  );
}
